import { render } from "./PasswordReset.vue?vue&type=template&id=1f02f3a0"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
script.render = render

export default script